(function() {
'use strict';

angular
    .module('dashboard')
    .factory('dashboardReviewService', dashboardReviewService);

function dashboardReviewService($http, $q, dashboardService, dashboardBookingService, imageService, resourceService, authService, currentUser) {
    const reviewUrl = '/api2/users/reviews/';
    const userReviewUrl = '/api2/users/reviews/user/';

    const ratingRange = {
        Min: 0,
        Max: 10
    };

    const sutabilityAnswers = [
        {
            name: resourceService.getDeferred('YES'),
            val: true
        },
        {
            name: resourceService.getDeferred('DASHBOARDRESOURCE_NO'),
            val: false
        },
        {
            name: resourceService.getDeferred('DASHBOARDRESOURCE_UNSURE'),
            val: 'Unsure'
        }
    ];

    const recommendTRPAnswers = [
        {
            name: resourceService.getDeferred('YES'),
            val: true
        },
        {
            name: resourceService.getDeferred('DASHBOARDRESOURCE_NO'),
            val: false
        }
    ];


    const reviewCriteria = [
        { name: resourceService.getDeferred('DASHBOARDRESOURCE_CHECKINDATE'), val: 'ReviewerCheckInDate' },
        { name: resourceService.getDeferred('DASHBOARDRESOURCE_MOSTLIKES'), val: 'LikeCount' },
        { name: resourceService.getDeferred('DASHBOARDRESOURCE_MYRATING'), val: 'Rating' },
        { name: resourceService.getDeferred('DASHBOARDRESOURCE_FEEDBACKDATE'), val: 'FeedBackDate' }
    ];

    let ratingTitles = null;
    let hotelSuitabilityTypes = null;

    const service = {
        getBookingFeedback,
        editReview,
        saveReview,
        recommendTRPChange,
        ratingRange,
        recommendTRPAnswers,
        sutabilityAnswers,
        getRatingTitles,
        getRatingTitleText,
        getStatements,
        getReviewSortCriteria,
        getReviewSiteDetails,
        getReview,
        getReviewHeaderData,
        getReviewStatus
    };


    function getStatements() {
        if (hotelSuitabilityTypes === null) {
            return $http.get(`${reviewUrl}getstatements?${$.param({
                CultureCode: TRPCONFIG.Domain.CultureCode
            })}`).then(function(result) {
                addDefaultAnswerToStatements(result.data);
                hotelSuitabilityTypes = result.data;
                return hotelSuitabilityTypes;
            });
        }
        return hotelSuitabilityTypes;
    }

    function addDefaultAnswerToStatements(data) {
        for (let i = 0; i < data.length; i++) {
            data[i].SelectedOpinion = sutabilityAnswers[2].val;
        }
    }

    function getRatingTitles() {
        if (ratingTitles === null) {
            return $http.get(`${reviewUrl}getratingcategories?${$.param({
                CultureCode: TRPCONFIG.Domain.CultureCode
            })}`).then(function(result) {
                ratingTitles = result.data;
                return ratingTitles;
            });
        }
        return $q.when(ratingTitles);
    }

    function BookingFeedback() {
        const feedback = {
            rating: 0,
            comments: '',
            topTip: '',
            notRecommendUsComment: '',
            statements: null
        };

        return feedback;
    }

    function getBookingFeedback() {
        const feedback = new BookingFeedback();
        feedback.statements = angular.copy(hotelSuitabilityTypes);
        feedback.recommendTRP = true;
        return feedback;
    }

    function editReview(hotel) {
        hotel.reviewSaved = false;
    }

    function saveReview(hotel, feedback, token, userId) {
        if (feedback.rating === 0) {
            hotel.submitTry = true;
            return $q.when(false);
        }

        return _saveReview(
            hotel.EstablishmentDetail.Id, hotel.BookingDetail.BookingId, feedback, token, userId
        ).then(function() {
            hotel.reviewSaved = true;
            dashboardService.clearAggregate();
            _setFeedbackStatements(
                hotel.BookingDetail.BookingId, hotel.EstablishmentDetail.Id, feedback.statements, token, userId);
            return true;
        });
    }

    function _saveReview(estabId, bookingId, reviewData, token, userId) {
        let url = '';

        const request = {
            BookingId: bookingId,
            ObjectId: estabId,
            RatingDecimal: reviewData.rating,
            Comments: reviewData.comments,
            TopTip: reviewData.topTip,
            RecommendTRP: reviewData.recommendTRP,
            NotRecommendUsComment: reviewData.notRecommendUsComment,
            DomainDefaultCultureCode: TRPCONFIG.Domain.CultureCode
        };

        if (token && userId) {
            request.VerificationToken = token;
            request.UserId = userId;
            url = `${userReviewUrl}settoken`;
        } else {
            url = `${userReviewUrl}set`;
        }

        return $http.post(url, request, { ignoreErrors: true });
    }

    function recommendTRPChange(feedback) {
        if (!feedback.recommendTRP) {
            feedback.showNotRecommendTRPComment = true;
            document.getElementById('review-content').scrollTop += 150;
            document.getElementById('notRecommendUsComment').focus();
        } else {
            feedback.showNotRecommendTRPComment = false;
        }
    }

    function getRatingTitleText(n) {
        if (n !== undefined) {
            let i = 0;
            if (n === 0) {
                return ratingTitles[i].Description;
            }
            for (i = 1; i < ratingTitles.length; i++) {
                if (n < ratingTitles[i].MinimumRating) {
                    return ratingTitles[i - 1].Description;
                }
            }
            return ratingTitles[i - 1].Description;
        }
        return '';
    }

    function getReviewSortCriteria() {
        return reviewCriteria;
    }

    function _setFeedbackStatements(bookingId, objectId, statements, token, userId) {
        const filteredStatements = _.filter(statements, function(s) {
            delete s.Description;
            return s.SelectedOpinion !== 'Unsure';
        });
        const request = {
            BookingId: bookingId,
            ObjectId: objectId,
            Statements: filteredStatements
        };
        if (filteredStatements.length > 0) {
            let url = '';

            if (token && userId) {
                request.VerificationToken = token;
                request.UserId = userId;
                url = `${userReviewUrl}setstatementstoken`;
            } else {
                url = `${userReviewUrl}setstatements`;
            }

            return $http.post(url, request, { ignoreErrors: true });
        }
        return $q.when();
    }

    function getReviewSiteDetails(bookingId) {
        return $http.get(`${userReviewUrl}getreviewsite?bookingId=${bookingId}&domainId=${TRPCONFIG.Domain.DomainId}`, { ignoreErrors: true }).then(
        function(result) {
            const reviewSiteDetails = result.data;
            return reviewSiteDetails;
        });
    }

    function getReview(bookingId) {
        return $http.get(`${userReviewUrl}booking/${bookingId}?cultureCode=${TRPCONFIG.Domain.CultureCode}`, { ignoreErrors: true })
            .then(function(result) {
                return result.data;
            });
    }

    function getReviewHeaderData(bookingId, objectId) {
        const dim = TRPCONFIG.DeviceSettings.LandingImageHeight;
        const hotelDetail = dashboardService.getHotelsById([objectId]);
        const bookingDetail = dashboardBookingService.getBookingSummary(bookingId);
        const contactDetail = dashboardBookingService.getContact(bookingId);

        return $q.all([hotelDetail, bookingDetail, contactDetail]).then(function(results) {
            const hotel = (results[0]) ? results[0][0] : null;
            const contact = results[2] && results[2].data;
            return {
                EstablishmentDetail: hotel,
                ImageUrl: imageService.getMainImageUrl(objectId, dim, dim),
                BookingDetail: {
                    StartDate: results[1].Booking.StartDate,
                    BookingRef: results[1].Booking.BookingRef,
                    BookingId: bookingId,
                    LeadPassengerContact: {
                        Title: contact.Title,
                        FirstName: contact.FirstName,
                        Surname: contact.LastName
                    }
                }
            };
        });
    }

    function getReviewStatus(bookingId) {
        const user = currentUser.get();
        return (user.AnonSignedIn ? authService.getSignedinBooking() : $.when()).then(booking => {
            if (booking && booking.Summary && booking.Summary.BookingId) {
                let url = `/api/bookings/${booking.Summary.BookingId}/trip?culturecode=${TRPCONFIG.Domain.CultureCode}`;
                return $http.get(url).then(response => {
                    let bk = _.find(response.data.Bookings, function(bk) {
                        return bk.BookingId === parseInt(bookingId);
                    });
                    return bk.ReviewStatus;
                });
            }
        });
    }
    return service;
}
})();
